export const pick = <
  TObj extends Record<string | number | symbol, unknown>,
  TKey extends keyof TObj,
>(
  obj: TObj,
  keys: Array<TKey>,
) => {
  return keys.reduce(
    (acc, key) => {
      if (key in obj) {
        acc[key] = obj[key];
      }
      return acc;
    },
    {} as Pick<TObj, TKey>,
  );
};
